import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { LoaderService } from "../service/loader.service";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";

@Component({
  selector: "app-example-monouse-component",
  template: `<std-modal cardClass="!max-w-[500px]" headerClass="bg-primary" [show]="step == 0"
    [closeOnOutside]="false" (close)="autoDestory()">
    <div class="text-tertiary text-title" header>
      Valutazione Bando: {{ selectedCustomItem?.title | slice:0:30 }}...
    </div>
    <div content class="custom-scrollbar max-h-[70vh] overflow-y-auto px-1">
      
      <div class="mt-4 grid gap-6">
        <div class="grid grid-cols-2 gap-4">
          <std-input customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="evaluationForm.partitaIva" label="Partita IVA" labelPosition="top" placeholder="Es. 12345678901"></std-input>
          
          @if (isFieldActive('dipendenti')) {
            <std-input customInputClass="custom-input" customLabel="label-input" [type]="'number'" [(ngModel)]="evaluationForm.numeroDipendenti" label="N. Dipendenti" labelPosition="top" placeholder="Es. 10"></std-input>
          }
        </div>

        @if (isFieldActive('startup')) {
           <div class="w-full">
            <std-select 
              label="Startup Innovativa" 
              labelPosition="top"
              customLabel="label-input"
              customClassContaier="border-primary custom-select"
              [data]="[{label: 'Sì', value: true}, {label: 'No', value: false}]"
              [bindLabel]="'label'"
              [bindValue]="'value'" 
              [currentValue]="evaluationForm.startup !== null ? {label: evaluationForm.startup ? 'Sì' : 'No', value: evaluationForm.startup} : null"
              (onChangeValue)="evaluationForm.startup = $any($event).value"
              placeholder="Seleziona opzione">
            </std-select>
          </div>
        }

        @if (isFieldActive('sedi')) {
          <div>
            <div class="font-semibold text-primary mb-2">Città Sedi</div>
            @for (citta of evaluationForm.cittaSedi; track $index) {
              <div class="flex gap-2 items-end mb-2">
                <std-input customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="citta.value" class="w-full" labelPosition="top" placeholder="Es. Palermo"></std-input>
                @if(evaluationForm.cittaSedi.length > 1){
                  <std-button (click)="removeField('cittaSedi', $index)" size="xs" type="primary" buttonClass="rounded-full min-w-[30px] size-[30px] bg-red-400 focus:bg-red-500 hover:bg-red-500 flex items-center justify-center mb-[4px]">
                    <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                  </std-button>
                }
              </div>
            }
            <div class="text-right mt-1">
              <span class="text-primary text-sm cursor-pointer underline font-medium" (click)="addField('cittaSedi')">+ Aggiungi città</span>
            </div>
          </div>
        }

        @if (isFieldActive('codici ateco')) {
          <div>
            <div class="font-semibold text-primary mb-2">Codici Ateco</div>
            @for (ateco of evaluationForm.codiciAteco; track $index) {
              <div class="flex gap-2 items-end mb-2">
                <std-input customInputClass="custom-input" customLabel="label-input" [type]="'text'" [(ngModel)]="ateco.value" class="w-full" labelPosition="top" placeholder="Es. 62.02.00"></std-input>
                @if(evaluationForm.codiciAteco.length > 1){
                  <std-button (click)="removeField('codiciAteco', $index)" size="xs" type="primary" buttonClass="rounded-full min-w-[30px] size-[30px] bg-red-400 focus:bg-red-500 hover:bg-red-500 flex items-center justify-center mb-[4px]">
                    <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                  </std-button>
                }
              </div>
            }
            <div class="text-right mt-1">
              <span class="text-primary text-sm cursor-pointer underline font-medium" (click)="addField('codiciAteco')">+ Aggiungi codice</span>
            </div>
          </div>
        }

        @if (isFieldActive('fatturato')) {
          <div>
            <div class="font-semibold text-primary mb-2">Fatturato Ultimi Bilanci (€)</div>
            @for (fatturato of evaluationForm.fatturati; track $index) {
              <div class="flex gap-2 items-end mb-2">
                <std-input customInputClass="custom-input" customLabel="label-input" [type]="'number'" [(ngModel)]="fatturato.value" class="w-full" labelPosition="top" [placeholder]="'Fatturato anno ' + ($index + 1)"></std-input>
                @if(evaluationForm.fatturati.length > 1){
                  <std-button (click)="removeField('fatturati', $index)" size="xs" type="primary" buttonClass="rounded-full min-w-[30px] size-[30px] bg-red-400 focus:bg-red-500 hover:bg-red-500 flex items-center justify-center mb-[4px]">
                    <svg class="size-[14px] fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                  </std-button>
                }
              </div>
            }
            <div class="text-right mt-1">
              <span class="text-primary text-sm cursor-pointer underline font-medium" (click)="addField('fatturati')">+ Aggiungi bilancio</span>
            </div>
          </div>
        }

      </div>

      <div class="mt-8 flex gap-4 pt-4 border-t border-gray-200">
        <std-button buttonClass="bg-tertiary text-primary focus:bg-tertiary hover:bg-tertiary shadow-md" 
          (click)="autoDestory()" class="w-full" type="secondary">
          Cancella
        </std-button>
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary shadow-md" 
          (click)="submitEvaluation()" class="w-full">
          Conferma Valutazione
        </std-button>
      </div>
    </div>
  </std-modal>
 @if(step == 1){ <std-modal cardClass="!max-w-[500px]" headerClass="bg-primary" [show]="step == 1"
    [closeOnOutside]="false" (close)="autoDestory()">
    <div class="text-tertiary text-title" header>
      Valutazione Bando: {{ selectedCustomItem?.title | slice:0:30 }}...
    </div>
    <div content class="custom-scrollbar max-h-[70vh] overflow-y-auto px-1">
    @if(!aiValutation.reason){  <div class="text-[16px] text-black mb-2"><span class="font-bold">Risultato:</span>{{aiValutation.motivation}}</div>
      <div class="text-[16px] text-black mb-2"><span class="font-bold">Descrizione:</span>{{aiValutation.reasoning}}</div>
      @if(aiValutation?.criticalIssues?.length > 0){<div class="text-[16px] text-black mb-2"><span class="font-bold">Problemi critici:</span>{{aiValutation.criticalIssues.join(' - ')}}</div>}
      <div class="text-[16px] text-black mb-2"><span class="font-bold">Criteri valutati:</span>{{aiValutation.evaluatedCriteria.join(' - ')}}</div>
      <div class="text-[16px] text-black mb-2"><span class="font-bold">Requisiti rispettati:</span>{{aiValutation.positiveMatches.join(' - ')}}</div>
      }@else{
        <div class="text-[16px] text-black mb-2"><span class="font-bold">Errore compilazione:</span>{{aiValutation.reason}}</div>
      }
      

      <div class="mt-8 flex gap-4 pt-4 border-t border-gray-200">
        <std-button buttonClass="bg-tertiary text-primary focus:bg-tertiary hover:bg-tertiary shadow-md" 
          (click)="autoDestory()" class="w-full" type="secondary">
          Chiudi
        </std-button>
        <std-button buttonClass="bg-tertiary text-primary focus:bg-tertiary hover:bg-tertiary shadow-md" 
          (click)="step = 0" class="w-full" type="secondary">
          Torna alla compilazione
        </std-button>
      </div>
    </div>
  </std-modal>}`,
  styles: [],
  standalone: false,
})
export class NoticeVerificationAdminComponent implements OnInit {
  // ... (Logica TS rimane invariata, ho solo aggiornato i placeholder nel template sopra)
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;
  selectedCustomItem: any = null;
  step = 0;
  activeCriteria: string[] = [];

  evaluationForm: any = {
    partitaIva: '',
    numeroDipendenti: null,
    cittaSedi: [{ value: '' }],
    codiciAteco: [{ value: '' }],
    fatturati: [{ value: null }, { value: null }, { value: null }],
    startup: null
  }
  aiValutation: any = {}
  constructor(private host: ElementRef<HTMLElement>, private loader: LoaderService, private message: Message, private rest: RestService) { }

  ngOnInit(): void {
    this.selectedCustomItem = this.fatherElement;

    this.activeCriteria = [];
    if (this.selectedCustomItem?.criteria) {
      try {
        if (Array.isArray(this.selectedCustomItem.criteria)) {
          this.activeCriteria = this.selectedCustomItem.criteria;
        } else {
          const parsed = JSON.parse(this.selectedCustomItem.criteria);
          this.activeCriteria = Array.isArray(parsed) ? parsed : [];
        }
      } catch (e) {
        console.error("Errore nel parsing dei criteri JSON:", e);
        this.activeCriteria = [];
      }
    }

    this.evaluationForm = {
      partitaIva: '',
      numeroDipendenti: null,
      cittaSedi: [{ value: '' }],
      codiciAteco: [{ value: '' }],
      fatturati: [{ value: null }, { value: null }, { value: null }],
      startup: null
    };
  }

  isFieldActive(field: string): boolean {
    if (field === 'partitaIva') return true;
    return this.activeCriteria.some(c => c?.toLowerCase().trim() === field.toLowerCase().trim());
  }

  addField(field: 'cittaSedi' | 'codiciAteco' | 'fatturati') {
    this.evaluationForm[field].push({ value: null });
  }

  removeField(field: 'cittaSedi' | 'codiciAteco' | 'fatturati', index: number) {
    this.evaluationForm[field].splice(index, 1);
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }

  submitEvaluation() {
    const payload: any = {
      partitaIva: this.evaluationForm.partitaIva
    };

    if (this.isFieldActive('dipendenti')) {
      payload.numeroDipendenti = Number(this.evaluationForm.numeroDipendenti);
    }

    if (this.isFieldActive('sedi')) {
      payload.cittaSedi = this.evaluationForm.cittaSedi
        .map((item: any) => item.value ? item.value.trim() : '')
        .filter((v: string) => v !== '');
    }

    if (this.isFieldActive('codici ateco')) {
      payload.codiciAteco = this.evaluationForm.codiciAteco
        .map((item: any) => item.value ? item.value.trim() : '')
        .filter((v: string) => v !== '');
    }

    if (this.isFieldActive('fatturato')) {
      payload.fatturatoUltimi3Bilanci = this.evaluationForm.fatturati
        .map((item: any) => Number(item.value))
        .filter((v: number) => !isNaN(v) && v > 0);
    }

    if (this.isFieldActive('startup')) {
      payload.startup = this.evaluationForm.startup;
    }

    const idToEvaluate = this.selectedCustomItem.id;
    const url = `/internal/evaluate/${idToEvaluate}`;

    this.loader.on();
    this.rest.post(url, payload).subscribe({
      next: (response: any) => {
        this.aiValutation = response
        this.loader.off(true);
        this.step = 1
        this.message.showMessage('Valutazione inviata con successo!', 'success');
      },
      error: (err: any) => {
        this.loader.off(true);
        if (err.status == 400) {
          this.aiValutation = {
            reason: 'I dati inseriti non sono corretti, ricompilare usando dati corretti e nel giusto formato'
          }
          this.step = 1
        } else {
          this.autoDestory()
        }
        this.message.showMessage('Errore durante l\'invio della valutazione', 'error');
        console.error(err);
      }
    });
  }
}